export default __webpack_public_path__ + "static/media/ISMO CLASS-6_SYLLABUS_2025-26.14debbc7.pdf";